export const FETCH_POSTS_SUCCESS = "FETCH_POSTS_SUCCESS";
export const FETCH_POSTS_REQUEST = "FETCH_POSTS_REQUEST";
export const FETCH_POSTS_FAIL = "FETCH_POSTS_FAIL";

export const FETCH_POST_REQUEST = "FETCH_POST_REQUEST";
export const FETCH_POST_SUCCESS = "FETCH_POST_SUCCESS";
export const FETCH_POST_FAIL = "FETCH_POST_FAIL";
export const FETCH_POST_CLEAR = "FETCH_POST_CLEAR";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const CHECK_AUTH_STATUS = "CHECK_AUTH_STATUS";

export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";

export const CREATE_POST_REQUEST = "CREATE_POST_REQUEST";
export const CREATE_POST_FAIL = "CREATE_POST_FAIL";
export const CREATE_POST_SUCCESS = "CREATE_POST_SUCCESS";

export const EDIT_POST_REQUEST = "EDIT_POST_REQUEST";
export const EDIT_POST_FAIL = "EDIT_POST_FAIL";
export const EDIT_POST_SUCCESS = "EDIT_POST_SUCCESS";

export const DELETE_POST_REQUEST = "DELETE_POST_REQUEST";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const DELETE_POST_FAIL = "DELETE_POST_FAIL";

export const SEARCH_POST = "SEARCH_POST";
